import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const ContactLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.contact',
    link: _context.isGar ? '/page/feedback-gar' : '/page/feedback',
    icon: 'navigation-link__contact',
});